import * as _ from 'lodash';
import messages from '../../const/messages';
import { IProject } from '../../models/IProject';

export function validateTagName(tagName: string, project: IProject, curTagId?: string) {
    if (!tagName) {
        return messages.tagIsEmpty;
    }

    const tags = curTagId ?
        _.filter(project.tags, (tag) => {
            return tag.tagId !== curTagId;
        }) :
        project.tags;

    if (project && _.find(tags, { message: tagName })) {
        return messages.tagAlreadyExists;
    }

    return null;
}